import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/Reveal";

export default function Challenge() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section ref={ref} className="relative py-28 sm:py-40 overflow-hidden border-y border-white/10 bg-surface/40">
      <motion.span
        style={{ y }}
        aria-hidden="true"
        className="text-outline font-display font-extrabold absolute top-1/2 -translate-y-1/2 left-0 whitespace-nowrap text-[22vw] leading-none select-none pointer-events-none opacity-60"
      >
        LA SFIDA
      </motion.span>

      <div className="relative max-w-4xl mx-auto px-6 sm:px-10 text-center">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-ember">
            Il mio motto
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <blockquote className="mt-8 font-display font-bold text-5xl sm:text-6xl lg:text-7xl leading-[1.05] text-ink">
            «Accetto <span className="text-ember italic">la sfida</span>.»
          </blockquote>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-10 font-mono text-sm text-zinc-500 tracking-wide">
            — Giango
          </p>
        </Reveal>
      </div>
    </section>
  );
}
